<script setup lang="ts">
import { onMounted, ref } from "vue";

const iconUrl = "/icon.png";
const isVisible = ref(false);
const isDismissed = ref(true);

const isStandalone =
  typeof window !== "undefined" &&
  (window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true);

const alreadyShown = typeof sessionStorage !== "undefined" && sessionStorage.getItem("condor-splash-shown");

if (isStandalone && !alreadyShown) {
  isDismissed.value = false;
  isVisible.value = true;
}

onMounted(() => {
  if (!isVisible.value) return;
  sessionStorage.setItem("condor-splash-shown", "1");
  setTimeout(() => {
    isVisible.value = false;
    setTimeout(() => {
      isDismissed.value = true;
    }, 400);
  }, 800);
});
</script>

<template>
  <div
    v-if="!isDismissed"
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-background transition-opacity duration-400"
    :class="isVisible ? 'opacity-100' : 'opacity-0'"
  >
    <div
      class="flex flex-col items-center gap-3 transition-transform duration-500"
      :class="isVisible ? 'scale-100' : 'scale-110'"
    >
      <img :src="iconUrl" alt="Condor" class="size-20 rounded-2xl" />
      <span class="text-lg font-semibold tracking-tight text-foreground">Condor</span>
    </div>
  </div>
</template>
